
const help = {

start: {
  title: "Hilfe & Support",
  subtitle: "Anleitungen, FAQs und Support-Kontakt. Wähle unten einen Bereich aus.",

  ui: {
    back: "Zurück",
    open: "Öffnen",
  },

  sections: {
    account: {
      title: "Kontoverwaltung",
      subtitle: "Anleitung zu Registrierung, Anmeldung und Einstellungen.",
    },
    platform: {
      title: "Plattform-Anleitung",
      subtitle: "So funktioniert Elnydo",
    },
    ads: {
      title: "Werbeanleitung",
      subtitle: "Anzeigen erstellen, Zielgruppen, Budgets, Überprüfung und Abrechnung.",
    },
    faq: {
      title: "FAQ",
      subtitle: "Schnelle Antworten – nach Themen sortiert, damit du Informationen schnell findest.",
    },
  },

  contact: {
    title: "Support kontaktieren",
    subtitle: "Wenn du weitere Hilfe benötigst, kannst du uns hier kontaktieren.",
    cta: "Kontakt",
  },
},

account: {
  pageTitle: "Kontoverwaltung",
  pageSubtitle:
    "Erstelle und verwalte dein Konto, stelle den Zugriff wieder her und verwalte deine Einstellungen für Datenschutz, Sicherheit und Benachrichtigungen.",

  ui: {
    back: "Zurück",
    backAria: "Zurück",
    backTitle: "Zurück",
    jumpHint: "Zu einem Thema springen:",
    overview: "Übersicht",
    copyLink: "Link kopieren",
    backToTop: "Nach oben",
    linkToTopicAria: "Link zu {{title}}",
    linkToTopicTitle: "Link zu {{title}}",
  },

  topics: {
    intro: {
      title: "Kontenübersicht",
      bullets: [
        "Dein Elnydo-Konto ist deine Identität auf der Plattform und wird für dein Profil, Beiträge, Likes, Follower, Benachrichtigungen sowie alle weiteren kontobezogenen Inhalte verwendet.",
        "Zu den grundlegenden Kontodaten gehören dein Profilname (maximal 18 Zeichen), deine E-Mail-Adresse und dein verschlüsselt (gehasht) gespeichertes Passwort.",
        "E-Mail-Adresse und Passwort können jederzeit im Einstellungsbereich geändert werden. Der Profilname eines bestehenden Kontos kann nicht geändert werden.",
      ],
    },

    registration: {
      title: "Konto erstellen",
      bullets: [
        "Um ein Profil zu erstellen, musst du einen Profilnamen, eine gültige E-Mail-Adresse und ein Passwort angeben.",
        "Dein Profilname kann nach der Erstellung nicht mehr geändert werden.",
        "Du musst bestätigen, dass du mindestens 18 Jahre alt bist, um ein Konto erstellen zu können.",
        "Alle Felder (Profilname, gültige E-Mail-Adresse, verschlüsseltes Passwort und Bestätigung des Mindestalters von 18 Jahren) sind erforderlich, um dein Profil erfolgreich zu erstellen.",
      ],
    },

    login: {
      title: "Anmelden",
      bullets: [
        "Melde dich mit deiner E-Mail-Adresse und deinem Passwort an.",
        "Falls du unerwartet abgemeldet wirst, überprüfe, ob deine Sitzung beendet wurde (zum Beispiel nach einem Sicherheitsupdate oder einer Abmeldung auf einem anderen Gerät).",
      ],
    },

    forgotPassword: {
      title: "Passwort vergessen",
      bullets: [
        "Wenn du dein Passwort vergessen hast, verwende die Funktion „Passwort vergessen“ auf dem Anmeldebildschirm.",
        "Ein Link zum Zurücksetzen des Passworts wird an die E-Mail-Adresse deines Kontos gesendet.",
        "Öffne den erhaltenen Link und wähle ein neues Passwort, um wieder Zugriff auf dein Konto zu erhalten.",
        "Nach der Bestätigung des neuen Passworts wirst du automatisch in dein Konto eingeloggt.",
      ],
    },

    settings: {
      title: "Einstellungen",
      bullets: [
        "Im Einstellungsbereich kannst du dein Konto verwalten.",
        "Die Einstellungen bestehen aus fünf Unterbereichen: 1. Kontoeinstellungen, 2. Daten & Datenschutz, 3. Sicherheit, 4. Profilverwaltung und 5. Hilfe & Support.",
      ],
    },

    accountSettings: {
      title: "Kontoeinstellungen",
      bullets: [
        "Profilname: Der Profilname kann nicht geändert werden. Du kannst ihn per E-Mail mit anderen Nutzern teilen, damit sie dich leichter finden.",
        "E-Mail-Adresse ändern: Aktualisiere die mit deinem Konto verknüpfte E-Mail-Adresse (für Anmeldung und Kontowiederherstellung). Zur Bestätigung musst du lediglich den Code eingeben, den wir an deine neue E-Mail-Adresse senden.",
        "Passwort ändern: Wähle ein neues Passwort, um dein Konto zu schützen. Der Vorgang erfolgt in zwei Schritten: Zuerst bestätigst du dein aktuelles Passwort, anschließend gibst du dein neues Passwort ein und bestätigst es. Nach dem Klick auf „Passwort aktualisieren“ wird das neue Passwort gespeichert.",
        "Sprache: Wähle deine bevorzugte Sprache aus dem Dropdown-Menü. Die Sprache wird sofort nach der Auswahl übernommen.",
        "Profil pausieren: Deaktiviere dein Profil und unterbreche alle Kontoaktivitäten, bis du es wieder aktivierst. Zur Bestätigung gibst du dein aktuelles Passwort ein. Für die Reaktivierung sind weder Passwort noch weitere Bestätigungen erforderlich. Dein Konto und deine Daten bleiben während der Deaktivierung vollständig erhalten.",
      ],
    },

    dataPrivacy: {
      title: "Daten & Datenschutz",
      bullets: [
        "Erforderliche Verarbeitung: Kontoverwaltung, Sicherheit, Integrität des Dienstes und nicht personalisierte Betriebsfunktionen. Diese Verarbeitung ist für den Betrieb des Dienstes notwendig und kann nicht deaktiviert werden.",
        "Standortberechtigungen: Lege fest, ob Elnydo auf den Standort deines Geräts zugreifen darf, um standortbezogene Funktionen bereitzustellen.",
        "Push-Benachrichtigungen: Aktiviere oder deaktiviere Benachrichtigungen und wähle aus, welche Arten von Benachrichtigungen du erhalten möchtest.",
        "Anonyme Analysen: Erlaube anonyme Nutzungsanalysen, um Leistung, Stabilität und Benutzerfreundlichkeit zu verbessern.",
        "Konto und Daten löschen: Lösche dein Konto und alle damit verbundenen Daten dauerhaft. Dieser Vorgang ist möglicherweise nicht rückgängig zu machen. Die Löschung erfolgt in zwei Schritten: Zuerst gibst du dein aktuelles Passwort ein, anschließend bestätigst du den sechsstelligen Code, den wir an deine registrierte E-Mail-Adresse senden. Nach der Bestätigung werden dein Konto sowie alle Beiträge, Unterhaltungen und Einstellungen endgültig gelöscht und können nicht wiederhergestellt werden.",
        "Daten exportieren: Du hast das Recht auf Auskunft über deine Daten. Mit „Meine Daten exportieren“ kannst du eine ZIP-Datei mit deinen auf unserer Plattform gespeicherten Daten herunterladen.",
        "Nutzungsbedingungen & Datenschutzerklärung: Öffnet die Nutzungsbedingungen und die Datenschutzerklärung von Elnydo in einem neuen Tab.",
        "Datenschutz: Öffnet die Datenschutzdokumentation von Elnydo in einem neuen Tab.",
      ],
    },

    security: {
      title: "Sicherheit",
      bullets: [
        "Zwei-Faktor-Authentifizierung (2FA): Füge beim Anmelden eine zusätzliche Sicherheitsstufe hinzu. Dies erfolgt über eine zweite E-Mail-Adresse. An diese wird ein Bestätigungscode gesendet, den du eingeben musst. Zusätzlich erhältst du Wiederherstellungscodes, falls die zweite E-Mail-Adresse nicht mehr erreichbar ist. Die Zwei-Faktor-Authentifizierung kann jederzeit deaktiviert werden.",
        "Von allen Geräten abmelden: Beende alle aktiven Sitzungen auf sämtlichen Geräten, wenn du vermutest, dass jemand unbefugt auf dein Konto zugegriffen hat.",
      ],
    },

    profileManagement: {
      title: "Profilverwaltung",
      bullets: [
        "Die Profilverwaltung enthält Schaltflächen zu allen Bereichen, die dein Profil betreffen.",
        "Dazu gehören: Mein Profil, Meine Beiträge, Benachrichtigungen, Mein Feed, Follower und Blockierte Nutzer. Diese Bereiche werden ausführlich in der Plattform-Anleitung erklärt.",
      ],
    },

    helpSupport: {
      title: "Hilfe & Support",
      bullets: [
        "Der Bereich Hilfe & Support bietet Unterstützung für die gesamte Plattform.",
        "Er ist in vier Bereiche unterteilt: Kontoverwaltung, Plattform-Anleitung, Werbeanleitung und einen Bereich mit häufig gestellten Fragen (FAQ).",
        "Außerdem kannst du über Hilfe & Support direkt Kontakt mit Elnydo aufnehmen, falls Probleme auftreten oder du weitere Unterstützung benötigst.",
      ],
    },
  },
},


platform: {
  pageTitle: "Plattform-Anleitung",
  pageSubtitle:
    "Diese Anleitung erklärt, was du auf Elnydo machen kannst: Beiträge entdecken, Inhalte hochladen, mit anderen interagieren, dein Profil und deine Beiträge verwalten sowie Sicherheitsfunktionen nutzen.",

  ui: {
    back: "Zurück",
    backAria: "Zurück",
    backTitle: "Zurück",
    jumpHint: "Zu einem Thema springen:",
    overview: "Übersicht",
    copyLink: "Link kopieren",
    backToTop: "Nach oben",
    linkToTopicAria: "Link zu {{title}}",
    linkToTopicTitle: "Link zu {{title}}",
  },

  topics: {
    gallery: {
      title: "Galerie",
      bullets: [
        "Die Galerie ist der Haupt-Feed von Elnydo.",
        "Beiträge werden zuerst nach Stadt, anschließend nach Land und danach nach weiteren Beiträgen gefiltert (benachbarte Länder werden bevorzugt).",
        "Innerhalb jedes Bereichs werden Beiträge nach Datum sortiert (neueste Beiträge zuerst).",
        "Du kannst Beiträge mit „Gefällt mir“ markieren und Nutzern folgen.",
        "In der Galerie kannst du nach Beiträgen suchen, die versteckte Hashtags enthalten. Diese Hashtags werden im Beitrag selbst nicht öffentlich angezeigt.",
      ],
    },

    preferences: {
      title: "Mein Feed",
      bullets: [
        "Mein Feed zeigt Beiträge von Nutzern, denen du folgst, sortiert nach Datum. Dort kannst du Nutzern auch entfolgen und Beiträge liken.",
        "In Mein Feed kannst du nach Beiträgen suchen, die versteckte Hashtags enthalten. Die Hashtags werden im Beitrag selbst nicht angezeigt.",
      ],
    },

    mylikes: {
      title: "Meine Likes",
      bullets: [
        "Meine Likes zeigt alle Beiträge, die du mit „Gefällt mir“ markiert hast, sortiert nach dem Zeitpunkt deiner Bewertung. Du kannst Likes jederzeit wieder entfernen.",
        "In Meine Likes kannst du nach Beiträgen suchen, die versteckte Hashtags enthalten. Diese Hashtags werden im Beitrag selbst nicht angezeigt.",
      ],
    },

    changeLocation: {
      title: "Standort ändern",
      bullets: [
        "Du kannst deinen Standort ändern, um Beiträge aus einem anderen Ort anzuzeigen.",
        "Ein Standortwechsel beeinflusst die Beiträge, die im Galerie-Feed angezeigt werden. Es werden Beiträge für den ausgewählten Standort gefiltert.",
        "Öffne dazu im Seitenmenü den Bereich „Standort ändern“.",
        "Wähle einen neuen Standort aus, indem du ihn anklickst oder danach suchst.",
        "Bestätige den ausgewählten Standort über die Bestätigungsschaltfläche in der linken Seitenleiste.",
        "Du kannst jederzeit schnell zu deinem aktuellen Gerätestandort zurückwechseln. Dafür muss die Standortberechtigung aktiviert sein.",
      ],
    },

    uploadPost: {
      title: "Beitrag hochladen",
      bullets: [
        "„Beitrag hochladen“ öffnet die Seite zum Erstellen eines neuen Beitrags.",
        "In der Webversion kannst du Videos und Bilder hochladen.",
        "Auf Mobilgeräten kannst du vorhandene Medien hochladen oder direkt mit der Kamera deines Geräts Fotos oder Videos aufnehmen.",
        "Du kannst mehrere Medien auswählen oder aufnehmen. Pro Beitrag sind maximal 8 Medien möglich.",
        "Für Bilder und Videos stehen verschiedene Filter zur Verfügung.",
        "Du kannst deinem Beitrag versteckte Hashtags hinzufügen. Diese werden für die Suche in Galerie, Mein Feed und Meine Likes verwendet, sind jedoch nicht öffentlich sichtbar.",
        "Sobald dein Beitrag fertig ist, klicke auf „Hochladen“, um ihn öffentlich in der Galerie zu veröffentlichen.",
      ],
    },

    musicInMedia: {
      title: "Musik in Medien",
      bullets: [
        "Du kannst Videos mit einem Musiktitel kombinieren.",
        "Tippe während des Uploads auf „Musik“, um die Liste der verfügbaren Titel zu öffnen.",
        "Du kannst Titel anhören, einen auswählen und anschließend den gewünschten Ausschnitt festlegen.",
        "Die Musik muss nicht am Anfang beginnen – du kannst einen beliebigen Abschnitt auswählen und mit deinem Video kombinieren.",
        "Auf Mobilgeräten kannst du Videos auch direkt mit Hintergrundmusik aufnehmen. Öffne dazu die Kamera, tippe auf das Musik-Symbol, wähle einen Titel und den gewünschten Ausschnitt aus und starte anschließend die Aufnahme.",
      ],
    },

    myProfile: {
      title: "Mein Profil",
      bullets: [
        "Mein Profil zeigt dein Profilbild (oder den Standard-Avatar), deinen Profilnamen, deinen Standort sowie deine Bio („Was man über mich wissen sollte“).",
        "Profilbild: Falls kein Profilbild festgelegt wurde, wird der Standard-Avatar (Geist auf blauem Hintergrund) angezeigt.",
        "Der Profilname ist öffentlich sichtbar und wird unter anderem in Benachrichtigungen verwendet.",
        "Der Standort kann jederzeit bearbeitet werden und darf beliebigen Text enthalten. Wir empfehlen jedoch die Angabe einer echten Stadt oder eines Landes.",
        "Die Bio kann jederzeit geändert werden.",
      ],
    },

    myPosts: {
      title: "Meine Beiträge",
      bullets: [
        "Meine Beiträge zeigt alle Beiträge, die du hochgeladen hast.",
        "Bei jedem Beitrag wird die Anzahl der Likes angezeigt. Außerdem kannst du sehen, wer deinen Beitrag gelikt hat (Profilname mit direktem Zugriff auf das Profil).",
        "Du kannst Beiträge löschen. Gelöschte Beiträge sind anschließend nicht mehr öffentlich sichtbar.",
        "Du kannst Beiträge bearbeiten, indem du – sofern unterstützt – einzelne Medien daraus entfernst.",
        "Du kannst Beiträge ausblenden, ohne sie zu löschen. Ausgeblendete Beiträge können jederzeit wieder eingeblendet werden.",
      ],
    },

    followersFollowing: {
      title: "Meine Follower & Ich folge",
      bullets: [
        "Meine Follower zeigt alle Nutzer, die dir folgen.",
        "Ich folge zeigt alle Nutzer, denen du folgst.",
        "In beiden Listen kannst du Profilbilder ansehen und Profile durch Anklicken des Profilnamens oder Profilbildes öffnen.",
        "Du kannst Nutzer direkt aus diesen Listen blockieren oder blockieren und gleichzeitig melden.",
      ],
    },

    visitProfiles: {
      title: "Profile besuchen",
      bullets: [
        "Um ein Profil zu öffnen, klicke irgendwo in der App auf einen Profilnamen oder ein Profilbild.",
        "Es öffnet sich die Profilansicht mit Profilbild, Profilname, Standort und Bio.",
        "Du kannst die Beiträge des Nutzers ansehen und mit „Gefällt mir“ markieren.",
        "Falls erforderlich, kannst du das Profil blockieren.",
      ],
    },

    notifications: {
      title: "Benachrichtigungen",
      bullets: [
        "Benachrichtigungen informieren dich, wenn jemand deinen Beitrag mit „Gefällt mir“ markiert, dir folgt oder dir eine Chat-Nachricht sendet.",
        "Jede Benachrichtigung zeigt den Profilnamen, das Profilbild sowie Datum und Uhrzeit der jeweiligen Aktion an.",
      ],
    },

    chat: {
      title: "Chat",
      bullets: [
        "Der Chat ermöglicht private Nachrichten zwischen Nutzern.",
        "Du kannst Textnachrichten senden und empfangen.",
        "Nachrichten werden mit branchenüblichen Sicherheitsmaßnahmen geschützt.",
        "Falls erforderlich, kannst du Nutzer direkt im Chat blockieren oder melden.",
      ],
    },

    safety: {
      title: "Sicherheit: Blockieren & Melden",
      bullets: [
        "Wenn du dich unwohl fühlst oder Inhalte siehst, die gegen die Regeln verstoßen, kannst du Nutzer und Beiträge blockieren oder melden.",
        "Durch das Blockieren werden Interaktionen unterbunden und unerwünschte Kontakte verhindert.",
        "Gemeldete Inhalte werden zur Überprüfung an die Moderation weitergeleitet. Inhalte, die gegen unsere Regeln verstoßen, können entfernt und Konten eingeschränkt werden.",
        "Falls eine unmittelbare Gefahr besteht, wende dich zuerst an die zuständigen Behörden. Die Meldefunktion innerhalb der App ist kein Notfalldienst.",
      ],
    },
    },
  },
} as const;



export default help;
